import { AppNavigationBridge } from './auth/AppNavigationBridge';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AuthProvider } from './auth/AuthContext';
import './styles/tokens.css';
import './styles/globals.css';
import './styles/presentation-standard.css';
import './styles/ipad-responsive.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode><AuthProvider><AppNavigationBridge /><App /></AuthProvider></StrictMode>,
);
